import React from 'react';

export const ScoreFactorsContext = React.createContext<any>(null);
